export default [
  {
    name: 'Campaign Report',
    description: 'Standard campaign report, that includes every post, story or video that is being tracked, across all platforms.',
    icon: 'file text outline',
    link: 'campaign',
    type: 'premium',
    color: 'pink',
    helpLink: 'http://help.dyzio.co/en/articles/5391082-campaign-report',
  },
  {
    name: 'Instagram Report',
    description: 'Basic Instagram report for Instagram-only campaigns. Includes Influencer summary cards, visualisation and engagement rates.',
    icon: 'instagram',
    link: 'instagram',
    type: 'premium',
    color: 'pink',
    helpLink: 'http://help.dyzio.co/en/articles/5391088-instagram-report',
  },
  {
    name: 'ROI Report',
    description: 'Analyse the ROI of each influencer on your campaign. Add a budget or gift value to each influencer to activate all the report data.',
    icon: 'dollar',
    link: 'roi',
    type: 'premium',
    color: 'pink',
    helpLink: 'https://help.dyzio.co/en/articles/2816572-roi-report',
  },
  {
    name: 'Earned Media Value',
    description: 'View the Impression EMV or Engagement EMV, at both the influencer and campaign level. Add CPMs in the campaign settings tab to activate all report data.',
    icon: 'calculator',
    link: 'emv',
    type: 'premium',
    color: 'pink',
    helpLink: 'https://help.dyzio.co/en/articles/4156487-how-to-calculate-earned-media-value-emv',
  },
  {
    name: 'Custom Instagram',
    description: 'Customisable report for Instagram-only campaigns. Includes images for all posts and stories, plus add your campaign overview, favorite posts and comments.',
    icon: 'instagram',
    link: 'instagram-custom',
    type: 'premium',
    color: 'pink',
    helpLink: 'https://help.dyzio.co/en/articles/5099207-custom-instagram-report',
  },
  // {
  //   name: 'Authorisation Report',
  //   description: 'See which influencers have successfully authenticated on your campaign. Access the campaign invite URLs, to share with your influencers if needed.',
  //   icon: 'lock',
  //   link: 'auth',
  //   type: 'premium',
  //   color: 'pink',
  //   helpLink: 'http://help.dyzio.co/en/articles/5391110-influencer-authorisation-report',
  // },
  {
    name: 'Insights Report',
    description: 'View the top performing influencers, posts and stories on your Instagram campaign. Filter and rank the results by different KPIs.',
    icon: 'file text outline',
    link: 'campaign-insights',
    type: 'premium',
    color: 'pink',
    helpLink: 'http://help.dyzio.co/en/articles/5631782-campaign-insights-report',
  },
  {
    name: 'Tiktok Report',
    description: 'Customisable report for TikTok campaigns. Includes images and data for all TikTok posts, plus add your campaign overview.',
    icon: 'file text outline',
    link: 'tiktok',
    type: 'premium',
    color: 'pink',
    helpLink: 'http://help.dyzio.co/en/articles/6778681-tiktok-custom-report',
  },
  {
    name: 'Follower Growth',
    description: 'View the follower growth of each influencers’ socials networks used in the campaign. Data updates every 4 days.',
    icon: 'line graph',
    link: 'followers',
    type: 'premium',
    color: 'pink',
    helpLink: 'http://help.dyzio.co/en/articles/5736419-follower-growth-report',
    organisations: ['f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96', 'ab432213-e637-492d-9377-05c2b52a7748'],
  },
  {
    name: 'Google Analytics',
    description: 'Track influencer post click activate through to your custom goals set-up in Google Analytics. Requires a Google Analytics integration and a bespoke report.',
    icon: 'google',
    link: 'ga',
    type: 'integration',
    subType: 'google',
    color: 'green',
    helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report',
  },
  {
    name: 'Shopify',
    description: 'Track Shopify sales and revenue, linked directly to your influencers’ social activity. Requires a Shopify integration and a bespoke report.',
    icon: 'shop',
    link: 'shopify',
    type: 'integration',
    subType: 'shopify',
    color: 'green',
    helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report',
  },
  {
    name: 'PrestaShop',
    description: 'Track PrestaShop sales and revenue, linked directly to your influencers’ social activity. Requires a PrestaShop integration and a bespoke report.',
    icon: 'shop',
    link: 'prestashop',
    type: 'integration',
    subType: 'prestashop',
    color: 'green',
    helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report',
  },
  {
    name: 'Paid Report',
    description: 'Add Facebook paid campaign date to the Campaign Report, requires a Facebook Ads Manager integration.',
    icon: 'money bill alternate outline',
    link: 'paid',
    type: 'integration',
    subType: 'facebook',
    color: 'green',
    helpLink: 'http://help.dyzio.co/en/articles/5391120-facebook-paid-report',
  },
  {
    name: 'Guaranteed Impressions',
    description: 'Merge Facebook paid data with organic post data to show the combined data for your campaign, requires a Facebook Ads Manager integration.',
    icon: 'line graph',
    link: 'gi',
    type: 'integration',
    subType: 'facebook',
    color: 'green',
    helpLink: 'http://help.dyzio.co/en/articles/5391122-guaranteed-impression-report',
  },
];



/** WEBPACK FOOTER **
 ** ./src/utils/report-types.js
 **/